import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import ServiceFetcher from '../../shared/libs/ServiceFetcher';
import { TryCatchGeneric, checkServerError } from '../../shared/utils';
import { ROUTES } from '../router';

const usePostRecalculate = (body) => {

  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [statusService, setStatusService] = useState({ data: undefined, error: undefined });

  const options = {
    method: 'POST',
    body,
  };

  const fetchRecalculate = async () => {
    setIsLoading(true);
    await TryCatchGeneric(
      () => ServiceFetcher('/recalculate', options),
      setStatusService,
      setIsLoading,
      () => { }
    );
  };

  const { data, error } = statusService;

  useEffect(() => {
    if (error && checkServerError(error)) history.push(ROUTES.ERROR)
  }, [error]);

  return {
    recalculation: data,
    isLoading,
    isError: error,
    fetchRecalculate,
  };
};

export default usePostRecalculate;
